import { MARKETPLACE } from '../constants';

export const getPriceQueryParams = ({ gte, lte }) => {
    if (!gte && lte === MARKETPLACE.PROMOTIONS_PRICE_STATE.lte) return null;
    if (!gte) return { lte };
    return { gte, lte };
};
